import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const IframeContent = ({
  chat_id,
  trainingPrompt = "Te llamas Relatividad IA, una empresa revolucionaria de inteligencia artificial que ayuda a las empresas a integrar soluciones de IA personalizadas para mejorar sus procesos. Tu objetivo es proporcionar información y asesoramiento sobre cómo la IA puede transformar diversas industrias. Utilizas ejemplos prácticos y casos de éxito para demostrar el impacto positivo de la IA.",
  URL_BASE = "https://paginaweb-relatividadia.d5akl8suhondc.us-east-1.cs.amazonlightsail.com/clonesIA",
  chatName = "Clones IA",
  chatImage = "https://via.placeholder.com/40"
}) => {
  const [messages, setMessages] = useState([{ role: "system", content: trainingPrompt }]);
  const [inputValue, setInputValue] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    let typingTimeout;
    if (isTyping) {
      typingTimeout = setTimeout(() => {
        setIsTyping(false);
      }, 7000);
    }
    return () => clearTimeout(typingTimeout);
  }, [isTyping]);

  useEffect(() => {
    const messagesContainer = messagesEndRef.current?.parentNode;
    if (messagesContainer) {
      const { scrollHeight, clientHeight } = messagesContainer;
      messagesContainer.scrollTop = scrollHeight - clientHeight;
    }
  }, [messages]);

  const sendMessage = (event) => {
    event.preventDefault();
    if (!inputValue.trim()) return;

    const userMessage = { role: "user", content: inputValue };
    setMessages([...messages, userMessage]);
    setInputValue('');
    setIsTyping(true);

    // Aquí cambia para que se envíe la lista completa de mensajes
    sendMessagesToAPI(messages.concat(userMessage));
  };

  const sendMessagesToAPI = (fullMessageList) => {
    let dataToSend = {
      messages: fullMessageList,
      identificador: 123
    };

    console.log('Sending data to API:', JSON.stringify(dataToSend));

    fetch(URL_BASE, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Psico-API-Key': '94705224-bhvg-4745-mac7-f15c455858f4'
        },
        body: JSON.stringify(dataToSend)
    })
    .then(response => {
        console.log('API response status:', response.status);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(data => {
        console.log('Received response from API:', data);
        const assistantResponse = { role: "assistant", content: data.response };
        setMessages(prevMessages => [...prevMessages, assistantResponse]);
    })
    .catch(error => {
        console.error('Error sending messages to API:', error);
    })
    .finally(() => {
        setIsTyping(false);
    });
  };

  const getMessageClassName = (role) => {
    return `message ${role === 'user' ? 'sent' : 'received'}`;
  };

  return (
    <div className="chat-container" data-chat-id={chat_id}>
      <div className="header" data-chat-id={chat_id}>
        <img src={chatImage} alt="Perfil" data-chat-id={chat_id} />
        <div data-chat-id={chat_id}>{chatName}</div>
      </div>
      <div className="messages" data-chat-id={chat_id}>
        {messages
          .filter(message => message.role !== "system")
          .map((message, index) => (
            <div key={index} className={getMessageClassName(message.role)} data-chat-id={chat_id}>
              {message.content}
            </div>
          ))
        }
        <div ref={messagesEndRef} />
        {isTyping && <div className="message typing" data-chat-id={chat_id}>escribiendo...</div>}
      </div>
      <form className="input-container" onSubmit={sendMessage} data-chat-id={chat_id}>
        <input
          className="input"
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Escribe un mensaje aquí..."
          data-chat-id={chat_id}
        />
        <button type="submit" className="send-button" data-chat-id={chat_id}>
          <FontAwesomeIcon icon={faPaperPlane} />
        </button>
      </form>
    </div>
  );
};

export default IframeContent;